module.exports = __webpack_public_path__ + "static/img/client.ea8c588.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/client.jpg
// module id = 2647
// module chunks = 1